import { constants } from './constants';
import actionCreatorFactory from 'typescript-fsa';
import { NotificationCustomMessage, INotificationCustomMessage } from "api/api"

const notificationCustomMessageCreator = actionCreatorFactory("notificationCustomMessage");


export const SaveCustomMessagesAction = notificationCustomMessageCreator.async<INotificationCustomMessage[], NotificationCustomMessage[]>(constants.SAVE_CUSTOM_MESSAGES);
export const GetCustomMessagesAction = notificationCustomMessageCreator.async<{ id: string }, INotificationCustomMessage[]>(constants.GET_CUSTOM_MESSAGES);
